import React, { useEffect, useRef, useState } from 'react';
import './MarqueeText.css';

// Показывает текст как есть, а если он не помещается в контейнер — бегущей строкой
const MarqueeText = ({ text, className = '' }) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [overflowing, setOverflowing] = useState(false);

  useEffect(() => {
    setOverflowing(false);
  }, [text]);

  useEffect(() => {
    const container = containerRef.current;
    const content = contentRef.current;
    if (!container || !content) return;

    const isOverflowing = content.scrollWidth > container.clientWidth + 1;
    if (isOverflowing !== overflowing) {
      setOverflowing(isOverflowing);
    }
  }, [text, overflowing]);

  return (
    <div ref={containerRef} className={`marquee-container ${className}`}>
      <span
        ref={contentRef}
        className={`marquee-content ${overflowing ? 'marquee-scrolling' : ''}`}
      >
        <span className="marquee-unit">{text}</span>
        {overflowing && <span className="marquee-unit" aria-hidden="true">{text}</span>}
      </span>
    </div>
  );
};

export default MarqueeText;
